var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 631,
    viewBox: "0 0 1440 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 631L1440 0.219971C1425.38 4.18292 1406.85 8.29706 1386.52 12.811C1327.19 25.9854 1252.53 42.5654 1214.8 68.7321C1187.4 87.7378 1173.55 107.944 1160.25 127.369C1140.22 156.61 1121.4 184.08 1059.36 203.016C1006.96 219.009 968.134 221.24 931.191 223.364C895.333 225.425 861.246 227.384 818.231 241.726C743.063 266.787 721.199 303.015 699.056 339.706C695.472 345.644 691.881 351.594 688.055 357.511C660.592 399.989 622.693 433.902 527.67 460.964C473.727 476.327 427.926 474.248 384.44 472.273C351.323 470.769 319.549 469.327 286.542 475.695C210.194 490.425 160.761 522.625 128.354 553.456C99.3684 581.031 49.1827 618.495 0.00012207 631L1440 631Z",
    fill: "url(#paint0_linear_2090_25)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2090_25",
    x1: 719.216,
    y1: 621.226,
    x2: 719.216,
    y2: 0.22019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465282"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBackground);
export default __webpack_public_path__ + "static/media/footerBackground.5de332c9da58e4dc2449a6683603fc4c.svg";
export { ForwardRef as ReactComponent };